import { Link } from "react-router-dom";
import Sidebare from "../Sidbare/Sidebare";
import "./setting.css"
import { NewSideBarAdmin } from "../../NewSideBarAdmin";
export default function SettingAdmin(){
    const handleGoBack = () => {
        window.history.back();
    };
    return <>
    <NewSideBarAdmin/>
    <div className="container mt-5 settings-container">

    <div className="settings-header">
        <h3 className="text-parametres">
            <i onClick={handleGoBack} className="bi bi-arrow-left-short arrow"></i> 
            Paramètres
        </h3>
        <p className="settings-subtitle">Gérez vos préférences de compte et de notification.</p>
    </div>

    <div className="settings">
        <div className="reglage card-style">
            <h6 className="text-compte">Compte</h6>
            <div className="reglage-content">
                <Link className="change-mail link-item" to={"/paramétres/email"}>
                    <div className="link-content"><i className="icon-mailpass bi bi-envelope"></i> Changer l'adresse mail</div>
                    <i className="bi bi-chevron-right chevron"></i>
                </Link>
                <div className="divider"></div>
                <Link className="change-mail link-item" to={"/paramétres/change-mot-de-passe"}>
                    <div className="link-content"><i className="icon-mailpass bi bi-key-fill"></i> Changer le mot de passe</div>
                    <i className="bi bi-chevron-right chevron"></i>
                </Link>
            </div>
        </div>
        
        <div className="reglage card-style">
            <h6 className="text-compte">Notification</h6>
            <div className="reglage-content">
                <div className="form-check form-switch switch-item">
                    <label className="form-check-label text-check" htmlFor="notif-sonores">Ne pas recevoir de notifications sonores</label>
                    <input className="form-check-input custom-switch" type="checkbox" id="notif-sonores" />
                </div>
                <div className="divider"></div>
                <div className="form-check form-switch switch-item">
                    <label className="form-check-label text-check" htmlFor="notif-apercus">Ne pas afficher d'aperçus de notifications</label>
                    <input className="form-check-input custom-switch" type="checkbox" id="notif-apercus" />
                </div>
            </div>
        </div>

        <div className="reglage card-style">
            <h6 className="text-compte">Information</h6>
            <div className="reglage-content">
                <p className="text-aide link-item info-link">Besoin d’aide ?</p>
                <div className="divider"></div>
                <p className="text-aide link-item info-link">Voir les politiques de confidentialité et les conditions d'utilisation</p>
            </div>
        </div>
    </div>
    </div>
    </>
}